function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'sage': 'rgb(141, 196, 153)','ivory': 'rgb(255, 255, 240)','taupe': 'rgb(72, 60, 50)','mocha': 'rgb(109, 59, 7)','blush': 'rgb(222, 93, 131)','dustyrose': 'rgb(220, 161, 161)','rust': 'rgb(183, 65, 14)','mauve': 'rgb(186, 136, 136)','burgundy': 'rgb(128, 0, 32)','cream': 'rgb(255, 253, 208)','espresso': 'rgb(78, 42, 42)','beige': 'rgb(240, 223, 204)','natural': 'rgb(199, 174, 126)','offwhite': 'rgb(250, 249, 246)','heathergrey': 'rgb(231, 231, 233)','heathergray': 'rgb(231, 231, 233)','khaki': 'rgb(213, 197, 138)','cocoa': 'rgb(120, 82, 56)','butteryellow': 'rgb(254, 254, 165)','mint': 'rgb(173, 235, 179)',};

    this.images = {'camo': 'url("//www.onceuponaskirt.com/cdn/shop/files/CAMO_68x.png?v=12360177870954664814")','floral': 'url("//www.onceuponaskirt.com/cdn/shop/files/FLORAL_68x.png?v=6747193335869740346")','denim': 'url("//www.onceuponaskirt.com/cdn/shop/files/DENIM_68x.png?v=8130680078605462965")','leopard': 'url("//www.onceuponaskirt.com/cdn/shop/files/LEOPARD_68x.png?v=5595860949477252693")','stripes': 'url("//www.onceuponaskirt.com/cdn/shop/files/STRIPES_68x.png?v=8954908907699505232")','tiedye': 'url("//www.onceuponaskirt.com/cdn/shop/files/TIEDYE_68x.png?v=3658611256067632766")','paisley': 'url("//www.onceuponaskirt.com/cdn/shop/files/PAISLEY_68x.png?v=15878031419331154250")','yellow-pink': 'url("//www.onceuponaskirt.com/cdn/shop/files/PINKYELLOW_68x.png?501")','multicolor': 'url("//www.onceuponaskirt.com/cdn/shop/files/MULTICOLOR_68x.jpg?v=17243265516871076356")','flag': 'url("//www.onceuponaskirt.com/cdn/shop/files/FLAG_68x.jpg?v=13388415574427640752")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
